module.exports = __webpack_public_path__ + "img/SMT_32_Mr_Daren_Lau.fa0422eb.jpg";